export function getFileNameAndExtension(filename) {
  const lastIndexOfDot = filename.lastIndexOf('.');
  return [filename.slice(0, lastIndexOfDot), filename.slice(lastIndexOfDot + 1)];
}
